import { editorGuards } from '@framework/guards/modules/editor/editorGuard';

import { onboardingGuard } from './onboardingGuard';

const handlers = [...editorGuards, onboardingGuard];

export default handlers;
